import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus,faCheck } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';
import { borderRadius15, borderRadius40, borderRadius50 } from '../../global/Variables.js';

import { GlobalButtonFinal } from '../../global/GlobalStyles';
import { getCookie } from 'cookies-next';
import Moment from 'react-moment';
import 'moment/locale/cs';
import 'moment/locale/en-gb';

import * as Sentry from '@sentry/nextjs';
import { LangContext } from '../../../../src/ConnectedIntlProvider';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../src/messages';

export const CommentStyled = styled.div`
    border-bottom: thin solid rgba(0, 0, 0, 0.10);
    padding-bottom: 15px;
    margin-bottom: 15px;
    position: relative;


    &.hide {
        display: none;
    }

    .commentHeader {
        overflow: hidden;

        .commentHeaderIcon,
        .commentHeaderName,
        .commentHeaderActions {
            float: left;
        }

        img {
            width: 35px;
            height: 35px;
            border-radius: ${borderRadius50};
        }

        .commentHeaderIcon {
            width: 36px;
            display: inline-block;
        }

        .commentHeaderName {
            width: 136px;
            padding-left: 10px;
            display: inline-block;
            text-align: left;

            h3 {
                //  margin-top: 4px;
                color: var(--black-60, #666) !important;
                margin-bottom: 0 !important;

                padding-bottom: 0 !important;
                font-family: 'Nunito Sans';
                font-size: 14px !important;
                font-style: normal;
                font-weight: 600 !important;
                line-height: normal !important;
            }

            span {
                font-size: 12px;
                position: relative;
                top: -5px;
            }
        }

        .commentHeaderActions {
            width: 84px;
            display: inline-block;
            //  display: block;

            svg,
            button {
                display: block;
            }

            button {
                margin: 0;
                width: 100%;
                text-align: center;
                padding: 0;
                padding-top: 4px;
                padding-bottom: 4px;

                svg {
                    margin: auto auto;
                }
            }

            .activeIcon {
                color: #3d55d7;

                span,
                svg {
                    color: #3d55d7;
                }
            }

            .statusButton {
                display: flex;
                width: 100%;
                font-size: 12px;
                padding: var(--Subscription-Nr-of-Users, 5px) 8px;

                align-items: center;
                gap: var(--Subscription-Nr-of-Users, 5px);

                flex-shrink: 0;
                border-radius: 30px;

                background: var(--White, #fff);
                margin-top: 0 !important;

                .statusColor {
                    background: var(--Yellow, #bbbbbb);
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    flex-shrink: 0;
                }

                &:hover {
                    background: #d9d9d9;
                }

                &.open {
                    .statusColor {
                        background: #FFC700;
                    }
                }

                &.resolved {
                    .statusColor {
                        background: #23c703;
                    }
                }

                &.rejected {
                    .statusColor {
                        background: #c70303;
                    }
                }

                &.cancelled {
                    .statusColor {
                        background: #9747FF;
                    }
                }
            }
        }
    }

    .commentContent {
        text-align: left;
        overflow-wrap: break-word;
        display: block;
        // padding-left: 9px;

        &:hover {
            cursor: pointer !important;

            .number {
                background: #C80000 !important;
            }
        }

        .reply {
            margin-top: 10px;
            border-top: thin solid rgba(0, 0, 0, 0.10);
            padding-top: 10px;

            img {
                width: 35px;
                height: 35px;

                border-radius: ${borderRadius50};
            }

            input {
                width: 210px;
                float: right;

                color: var(--black-60, #666);
                /* Comments/Input */
                font-family: "Nunito Sans";
                font-size: 14px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
            }

            .commentButtons {
                height: 48px;
                padding-left: 47px;
                margin-right: -4px;
            }
        }

        .commentButtons {
            //  margin-top: 10px;

            button {
                font-size: 14px;
                padding-left: 15px;
                padding-right: 15px;
                float: right;
                width: 47% !important;

                svg {
                    font-size: 14px !important;
                    top: 0;
                    width: 16px !important;

                    path {
                        fill: white !important;
                    }

                    color: white;
                }
            }
        }

        input {
            margin-left: 2px;
            width:100%;
        }

        .number {
            border-radius: 50%;
            background: gray;
            width: 23px;
            height: 23px;
            text-align: center;
            position: absolute;
            margin-left: 6px;
            right: 0;
            top: 35px;

            span {
                color: white;
                font-size: 8pt;
                margin: auto auto;
                float: none;
                margin-top: -5px;
                top: -1px;
                position: relative;
            }

            &.activeNumber {
                background: #C80000;
            }
        }

        .text {
            padding-left: 0;
            margin-left: 0;
            width: 85%;
            display: inline-block;

            &.new {
                width: 100%;
                padding: 0;
                margin: 0;
                margin-top: 15px;
            }

            textarea {
                width: 100%;

                color: var(--black-60, #666);
                /* Comments/Input */
                font-family: "Nunito Sans";
                font-size: 14px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
                transition: all 0.3s ease;
                resize: none;
                border: thin solid rgba(0, 0, 0, 0.10);
                border-radius: 10px;
                padding: 5px;

                &:focus {
                    border: 1px solid #3D55D7;
                    outline: none;
                }
            }
        }

        .repliesAll {
            // padding-left: 35px;
            margin-top: 10px;
            // border-top: 1px solid lightgray;

            .replyHeader {
                width: 100%;
                height: 55px;
            }

            .replyIcon,
            .replyName {
                float: left;
            }

            .replyIcon {
                width: 36px;
                display: inline-block;
            }

            .replyName {
                width: 210px;
                padding-left: 10px;
                display: inline-block;
                text-align: left;

                h3 {
                    //  margin-top: 4px;
                    color: var(--black-60, #666) !important;
                    margin-bottom: 0 !important;

                    padding-bottom: 0 !important;
                    font-family: 'Nunito Sans';
                    font-size: 14px !important;
                    font-style: normal;
                    font-weight: 600 !important;
                    line-height: normal !important;
                }

                span {
                    font-size: 12px;
                }
            }

            h3 {
                margin-top: 0 !important;
                color: var(--black-60, #666) !important;
                margin-bottom: 0 !important;
                display: inline-block;
                padding-bottom: 0 !important;
                font-family: 'Nunito Sans';
                font-size: 14px !important;
                font-style: normal;
                font-weight: 600 !important;
                line-height: normal !important;
            }

            img {
                width: 35px;
                height: 35px;
                margin-right: 10px;
                border-radius: ${borderRadius50};
            }

            > div {
                padding-top: 10px;
                margin-top: 10px;
            }

            span {
                width: 100%;
            }

            > div:not(:last-child) {
                //  border-bottom: 1px solid lightgray;
            }

            .textMain {
                margin-top: -5px;
                //   padding-bottom:10px;
                padding-left: 47px;
                width: 100%;
                display: block;
            }

            .replyDate {
                font-size: 12px;
                display: block;
                margin-top: 0;
                padding-top: 0;
                position: relative;

            }
        }
    }

    .commentActions {
        background: white;
        position: absolute;

        border-radius: ${borderRadius15};
        //box-shadow: rgb(0 0 0 / 12%) 4px 4px 8px 2px, rgb(0 0 0 / 4%) 0px 0px 0px 3px;
        top: 35px;
        transition: all 0.3s ease;
        right: 0;
        overflow: hidden;
        padding: 10px;
        box-shadow: unset;
        width: 0;
        opacity: 0;
        transform: translateX(300px);
        z-index: 9;

        &.statusOpened {
            min-height: 170px;
        }

        &.commentsActionsOpened {
            box-shadow: rgb(0 0 0 / 12%) 4px 4px 8px 2px, rgb(0 0 0 / 4%) 0px 0px 0px 3px;
            width: 105px;
            opacity: 1;
            transform: translateX(0);
        }

        ul {
            list-style-type: none;
            text-align: left;
            margin: 0;
            padding: 0;
            transition: all 0.3s ease;

            li {
                margin-top: 0px;
                border-radius: ${borderRadius40};
                transition: all 0.3s ease;
                position: relative;
                font-size: 15px;
                padding: 7px;

                svg {
                    width: 15px;
                    height: auto;
                    top: 2px;
                    position: relative;
                    max-height: 15px;
                }

                span {
                    margin-left: 7px;
                }

                &:hover {
                    background: #c5c5c5;
                }

                .chevronRight {
                    right: 6px;
                    top: 9px;
                    opacity: 0.5;
                    position: absolute;
                }
            }

            &.statusCommentActions {
                position: absolute;
                //padding:15px;
                width: 85%;
                padding-top: 10px;
                transition: all 0.3s ease;
                top: 0;
                transform: translateX(160px);

                &.statusOpened {
                    transform: translateX(0);
                }
            }

            &.mainCommentActions {
                transform: translateX(0);

                &.statusOpened {
                    transform: translateX(-160px);
                    //   transform:translateX(0);
                }

                li {
                    padding: 5px;
                    height: 20px;
                    margin: 0;


                    &:not(:first-child) {
                        margin-top: 10px;
                    }

                    span {
                        color: var(--black-60, #666);
                        text-align: center;
                        font-family: 'Nunito Sans';
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 300;
                        line-height: normal;
                        top: -3px;

                        float: left;
                        width: 50px;
                        text-align: left;
                        display: inline-block;
                        position: relative;
                    }
                }

                .statusColor {
                    background: var(--Yellow, #bbbbbb);
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    flex-shrink: 0;
                    float: left;

                    &.open {

                        background: #FFC700;

                    }

                    &.resolved {

                        background: #23c703;

                    }

                    &.rejected {

                        background: #c70303;

                    }

                    &.cancelled {

                        background: #9747FF;

                    }
                }


                .divider {
                    height: 1px !important;
                    margin: 0 !important;
                    width: 100%;
                    background: lightgray;
                    padding: 0;
                    margin-top: 10px !important;
                }

            }
        }
    }
`;

function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
}

export default function Comment({
    props: any,
    created,
    addTempComment,
    userAvatar,
    userName,
    number,
    countComments,
    activeComment,
    setActiveComment,
    triggerDeleteComment,
    myAvatar,
    commentUUID,
    commentsAll,
    status,
    text,
    type,
    toggleInput,
    hide,
    cancelAddComment,
    versionUUID,
    position,
    finishComments,
}) {
    const [statusComment, setStatusComment] = useState('open');


    const [statusActions, changeStatusActionsOpened] = useState(false);

    const [commentsActions, changeCommentsActions] = useState(false);

    const [userInputNew, setUserInputNew] = useState('');

    const setUserInputNewChange = function (e: React.FormEvent<HTMLInputElement>) {
        setUserInputNew(e.currentTarget.value);
        if (userInputNew.length > 0) {
        }
    };

    const myRef = useRef(null);

    const [replyFocused, setIsReplyFocused] = useState(true);
    const [userInputReply, setUserInputReply] = useState('');

    const setUserInputReplyHandle = function (e: React.FormEvent<HTMLInputElement>) {
        setUserInputReply(e.currentTarget.value);
    };

    const useFocus = () => {
        const htmlElRef = useRef(null);
        const setFocus = () => {
            htmlElRef.current && htmlElRef.current.focus();
        };

        return [htmlElRef, setFocus];
    };

    const [isEdit, setIsEdit] = useState(false);

    const activateEdit = () => {
        changeCommentsActions(false);
        setUserInputNew(text);
        setIsEdit(true);

    };

    const [inputRef, setInputFocus] = useFocus();

    const toggleInputInside = useCallback((): void => {

        setInputFocus();
    }, []);
    useEffect(() => {
        toggleInput && toggleInput(toggleInputInside);
    }, [toggleInput, toggleInputInside]);

    useEffect(() => {
        if (status) {

            setStatusComment(status);
        }
    }, [status]);


    // addNewReplyAPI

    const changeStatusAPI = (newStatus) => {


        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'corrections/' + commentUUID, {
            method: 'PUT',
            body: JSON.stringify({
                status: newStatus,
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + getCookie('userTeam'), // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('corrections/(status)' + commentUUID + data.message + ' : ' + getCookie('userMail'));
                }

                if (data.message === undefined) {

                    setStatusComment(newStatus);
                    changeCommentsActions(false);
                    finishComments(versionUUID);
                }
            });
    };

    const [disabledInput, setDisabledInput] = useState(false);


    const addNewReplyAPI = () => {


        setDisabledInput(true);

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'corrections/' + commentUUID + '/comments', {
            method: 'POST',
            body: JSON.stringify({
                text: userInputReply,
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + getCookie('userTeam'), // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('corrections/' + commentUUID + '/comments' + data.message + ' : ' + getCookie('userMail'));
                }

                if (data.message === undefined) {

                    setUserInputReply('');
                    finishComments(versionUUID,null,data,number);
                    setDisabledInput(false);
                }
            });
    };

    const editCommentAPI = () => {

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'corrections/' + commentUUID, {
            method: 'PUT',
            body: JSON.stringify({
                text: userInputNew,
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + getCookie('userTeam'), // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('corrections/version/' + versionUUID + data.message + ' : ' + getCookie('userMail'));
                }

                if (data.message === undefined) {
                    setIsEdit(false);

                    finishComments(versionUUID);
                }
            });
        //
    };

    const addNewCommentAPI = () => {

        fetch(process.env.NEXT_PUBLIC_OBALERO_API_BASEPATH + 'corrections/version/' + versionUUID, {
            method: 'POST',
            body: JSON.stringify({
                position: {
                    x: position.x,
                    y: position.y,
                    z: position.z,
                },
                text: userInputNew,
                status:"open"
            }),
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + getCookie('userTeam'), // notice the Bearer before your token
            },
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.message !== undefined) {
                    Sentry.captureException('corrections/version/' + versionUUID + data.message + ' : ' + getCookie('userMail'));
                }

                if (data.message === undefined) {

                    finishComments(versionUUID,data.data.number,data);
                 //   setActiveComment(data.data.number);
                }
            });
        //
    };

    const ref = useRef(null);

    useEffect(() => {
        const handleOutSideClick = event => {
            if (!ref.current?.contains(event.target)) {
                //     alert("Outside Clicked.");
                changeCommentsActions(false);
            }
        };

        window.addEventListener('mousedown', handleOutSideClick);

        return () => {
            window.removeEventListener('mousedown', handleOutSideClick);
        };
    }, [ref]);



    const disableComment = function (e: React.FormEvent<HTMLInputElement>) {
        if(e.target.dataset.closecomment === "close"){
            setActiveComment(null);
        }


    };

    useEffect(() => {

        if(number || activeComment){
            if (myRef.current) {
                myRef.current.scrollIntoView({block: "start", behavior: 'smooth' });
                myRef.current.scrollBy(0, -100); // Adjust scrolling with a negative value here
            }
            setTimeout(function(){
                if (myRef.current) {
                    myRef.current.scrollIntoView({block: "start", behavior: 'smooth' });
                    myRef.current.scrollBy(0, -100);
                }
            },800);

        }
    }, [number,  activeComment]);

    const _handleKeyDown = (e, type) => {
        if (e.key === 'Enter') {
            if(type=== "reply"){
                addNewReplyAPI();
            }
            if(type=== "new"){
                addNewCommentAPI();
            }
        }
    }

    const { language, setLanguage } = useContext(LangContext);

    return (
        <CommentStyled className={hide ? "hide" : null}
                       ref={activeComment ?  myRef : null}
        >


            <div className={'commentHeader'} >
                <div className={'commentHeaderIcon'}>
                    <img src={userAvatar} data-closecomment={"close"}/>
                </div>

                <div className={'commentHeaderName'}>
                    <h3 data-closecomment={"close"}>{userName.length> 12?userName.substring(0, 12) + '...' : userName}</h3>

                    {type !== 'new' ?
                        <span data-closecomment={'close'}>

                        {created ?
                            <Moment fromNow locale={language === "cs" ? "cs" : "en-gb"}>{created.datetime}</Moment> : null}
                    </span>
                        :
                        <span data-closecomment={'close'}>
                        <FormattedMessage {...messages.editor_comments_new}></FormattedMessage>
                    </span>
                    }

                </div>

                {type !== 'new' ?
                <div className={'commentHeaderActions'}>
                    <button
                        className={`statusButton  ${status === 'new' ? 'new' : ''}  ${status === 'open' ? 'open' : ''} 
                         ${status === 'resolved' ? 'resolved' : ''} 
                                ${status === 'rejected' ? 'rejected' : ''} 
                                   ${status === 'cancelled' ? 'cancelled' : ''}   `}
                        onClick={() => changeCommentsActions(true)}
                    >
                        <div className={'statusColor'}></div>

                        {language === "cs"?
                        <>
                            {status == "open" ?
                            <>Otevřeno</> : null}
                        </>
                        : null}

                        {language === "cs"?
                            <>
                                {status == "resolved" ?
                                    <>Vyřešeno</> : null}
                            </>
                            : null}
                        {language === "cs"?
                            <>
                                {status == "rejected" ?
                                    <>Zamítnuto</> : null}
                            </>
                            : null}
                        {language === "cs"?
                            <>
                                {status == "cancelled" ?
                                    <>Zrušeno</> : null}
                            </>
                            : null}

                        {language !== "cs"?
                            <>
                                {capitalize(status)}
                            </>
                            : null}



                    </button>
                </div>
                : null}

            </div>

            <div className={'commentContent'} onClick={number && !activeComment ? () => setActiveComment(number) : (e) => disableComment(e)}>


                {type !== 'new' ?
                            <div className={activeComment ? 'number activeNumber' : 'number'} data-closecomment={"close"}>
                                        <span>{number ? number : countComments + 1}</span>
                            </div>
               : null}


                <div className={type === "new" ? 'new text' : "text"}>
                    {type !== 'new' ? (
                        <>
                        {!isEdit ?
                            <span data-closecomment={'close'}>{text}</span>
                            :
                            <>
                            <input

                                autoFocus
                                //onFocus={() => setIsReplyFocused(true) }
                                //  onBlur={() => setIsReplyFocused(false)}
                                value={userInputNew}
                                onChange={setUserInputNewChange}
                            />
                                <div className={'commentButtons'} style={{marginTop:"3px"}}>
                                    <GlobalButtonFinal
                                        style={{     marginRight: "-6px",  marginLeft: "12px" }}
                                        className={'backgroundBlue btn-circle smallest'}
                                        onClick={() => editCommentAPI()}
                                    >
                                        <FontAwesomeIcon style={{    marginRight: "3px"}} className={'iconBtn'} icon={faCheck} />
                                        <FormattedMessage {...messages.editor_comments_save}></FormattedMessage>

                                    </GlobalButtonFinal>

                                    <GlobalButtonFinal className={'borderBlue btn-circle smallest'} onClick={() => setIsEdit(false)}>
                                        <FormattedMessage {...messages.editor_comments_cancel}></FormattedMessage>

                                    </GlobalButtonFinal>
                                </div>
                            </>

                    }
                </>
                ) : (
                <>
                    <textarea autoFocus value={userInputNew} onChange={setUserInputNewChange} />
                    <div className={'commentButtons'}>


                        <GlobalButtonFinal
                            style={language === "cs" ? { fontSize:"12px",marginRight: "-4px",  marginLeft: "15px" } : { marginRight: "-4px",  marginLeft: "15px" }}
                            className={'backgroundBlue btn-circle smallest'}
                            onClick={() => addNewCommentAPI()}
                        >
                            <FontAwesomeIcon className={'iconBtn'} icon={faCheck} />
                            <FormattedMessage {...messages.editor_comments_comment}></FormattedMessage>

                        </GlobalButtonFinal>

                        <GlobalButtonFinal className={'borderBlue btn-circle smallest'} onClick={() => cancelAddComment()}>
                            <FormattedMessage {...messages.editor_comments_cancel}></FormattedMessage>
                                </GlobalButtonFinal>
                            </div>
                        </>
                    )}
                </div>
                { commentsAll && commentsAll.length >0 ? (
                    <div className={'repliesAll'}>
                        {commentsAll &&
                            commentsAll.map((value, index) => {

                                return (
                                    <div>
                                        <div className={'replyHeader'}>
                                            <div className={'replyIcon'}>
                                                <img src={value.created.user.avatar} />
                                            </div>
                                            <div className={'replyName'}>
                                                <h3 data-closecomment="close"> {value.created.user.full_name.length ? value.created.user.full_name.substring(0, 15) + '...' : value.created.user.full_name}</h3>
                                                <span className={'replyDate'}>

                                                    {created ?
                                                        <Moment locale={language === 'cs' ? 'cs' : 'en-gb'}
                                                                fromNow>{created.datetime}</Moment> : null}
                                                </span>
                                            </div>
                                        </div>


                                        <span className={'textMain'}>{value.text}</span>
                                    </div>
                                );
                            })}
                    </div>
                ) : null}

                {activeComment && type !== 'new' ? (
                    <div className={'reply'}>
                        <img src={myAvatar} />

                        <FormattedMessage {...messages.editor_comments_reply}>
                            {(msg) => (
                                <input
                                    autoFocus
                                    onKeyDown={(e) => _handleKeyDown(e, 'reply')}
                                    placeholder={msg+'...'}
                                    value={userInputReply}
                                    onChange={setUserInputReplyHandle}
                                    disabled={disabledInput}
                                />
                            )}
                        </FormattedMessage>


                        <div className={'commentButtons'}>
                            <GlobalButtonFinal
                                style={{ marginLeft: '10px' }}
                                className={'backgroundBlue btn-circle smallest'}
                                onClick={() => addNewReplyAPI()}
                            >
                                {/*<FontAwesomeIcon className={'iconBtn'} icon={faPlus} />*/}
                                <FormattedMessage {...messages.editor_comments_reply}></FormattedMessage>
                            </GlobalButtonFinal>

                            <GlobalButtonFinal className={'borderBlue btn-circle smallest'} onClick={() => setActiveComment(false)}>
                                <FormattedMessage {...messages.editor_comments_cancel}></FormattedMessage>
                            </GlobalButtonFinal>
                        </div>
                    </div>
                ) : null}
            </div>

            <div ref={ref} className={`commentActions ${commentsActions ? 'commentsActionsOpened' : ''}  ${statusActions ? 'statusOpened' : ''}`}>
                <ul className={`mainCommentActions ${statusActions ? 'statusOpened' : ''} `}>
                    <li onClick={() => changeStatusAPI("open")}>
                        <div className={'statusColor open'}></div>
                        <span>   <FormattedMessage {...messages.editor_comments_open}></FormattedMessage> </span>
                    </li>
                    <li onClick={() => changeStatusAPI('resolved')}>
                        <div className={'statusColor resolved'}></div>
                        <span> <FormattedMessage {...messages.editor_comments_resolved}></FormattedMessage></span>
                    </li>
                    <li onClick={() => changeStatusAPI('rejected')}>
                        <div className={'statusColor rejected'}></div>
                        <span> <FormattedMessage {...messages.editor_comments_rejected}></FormattedMessage></span>
                    </li>
                    <li onClick={() => changeStatusAPI('cancelled')}>
                        <div className={'statusColor cancelled'}></div>
                        <span> <FormattedMessage {...messages.editor_comments_cancelled}></FormattedMessage></span>
                    </li>

                    <li className={'divider'}></li>

                    <li onClick={() => activateEdit()} >
                        <span> <FormattedMessage {...messages.editor_comments_edit}></FormattedMessage></span>
                    </li>
                    <li onClick={()=>triggerDeleteComment(commentUUID)} style={{marginTop:"5px"}}>
                        <span>  <FormattedMessage {...messages.editor_comments_delete}></FormattedMessage> </span>
                    </li>
                </ul>
            </div>
        </CommentStyled>
    );
}
